import _ from 'underscore';

export const viewModelToBulkModelForDisclaimerAssociation = ({ campaignViewModel }) => {
  const associations = campaignViewModel.data.AdExtensionAssociations || [];
  const bulkAssociations = associations.map(association => _.omit(association, ['Client Id', 'Name']));
  return { AdExtensionAssociations: bulkAssociations };
};
